import React, {PureComponent} from 'react';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';

import {withUser} from '../../lib/user';
import ActionCard from '../../components/ActionCard';
import Button from '../../components/Button';
import Dialog from '../../components/Dialog';
import Icon from '../../components/Icon';
import {T} from '../../components/I18n';

class ReminderCard extends PureComponent {
  state = {
    confirmDelete: false
  };

  render() {
    const {reminder, location: {search}, onDelete} = this.props;
    const {confirmDelete} = this.state;

    return (
      <ActionCard
        active={confirmDelete}
        title={<T noTranslate>{reminder.message}</T>}
        description={getTimeOfDay(reminder)}
        tags={<ReminderGroupTags groups={reminder.groups} />}
        action={
          <Button.Group>
            <Button to={`/reminders/${reminder.id + search}`}>Edit</Button>
            <Button onClick={() => this.setState({confirmDelete: true})}><Icon name="trash-2" /></Button>
          </Button.Group>
        }
        overlay={confirmDelete && (
          <SmallDialog
            title="Delete this reminder?"
            description={reminder.repeatInterval
              ? "Are you sure you want to delete this recurring reminder?"
              : "Are you sure you want to delete this reminder?"
            }
            buttons={[
              <Button key="delete" onClick={() => onDelete(reminder)}>Delete</Button>,
              <Button key="cancel" secondary onClick={() => this.setState({confirmDelete: false})}>Cancel</Button>
            ]}
          />
        )}
      />
    );
  }
}

class ReminderGroupTags extends PureComponent {
  state = {
    showAll: false
  };

  render() {
    const DISPLAY_COUNT = 2;
    const {groups} = this.props;
    const {showAll} = this.state;

    if (groups.length < 1) {
      return <GlobalGroupTag>Global</GlobalGroupTag>;
    }
  
    if (showAll || groups.length <= DISPLAY_COUNT) {
      return groups.map(group => (
        <ActionCard.Tag key={group.id}>{group.name}</ActionCard.Tag>
      ));
    }
  
    return [
      ...new Array(DISPLAY_COUNT).fill(null)
        .map((_, i) => groups[i])
        .map(group => (
          <ActionCard.Tag key={group.id}><T noTranslate>{group.name}</T></ActionCard.Tag>
        )),
      <ActionCard.Tag key="show_more" blank onClick={() => this.setState({showAll: true})}>
        +{groups.length - DISPLAY_COUNT} more
      </ActionCard.Tag>
    ];
  }
}

function getTimeOfDay(reminder) {
  const date = new Date(reminder.scheduleTime);

  if (!reminder.repeatInterval) {
    return `At ${getFriendlyTime(date)}`;
  }

  if (reminder.repeatInterval === 'HOUR') {
    if (date.getMinutes() === 0) {
      return 'Every hour';
    }

    return `Every hour at ${date.getMinutes()} minutes past the hour`;
  }

  return `Every ${reminder.repeatInterval.toLowerCase()} at ${getFriendlyTime(date)}`;
}

function getFriendlyTime(date) {
  let hours = date.getHours() % 12;
  let minutes = date.getMinutes();
 
  if (hours === 0) {
    hours = 12;
  }

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  return `${hours}:${minutes} ${date.getHours() > 11 ? 'PM' : 'AM'}`;
}

const SmallDialog = styled(Dialog)`
  width: 20rem;
`;

const GlobalGroupTag = styled(ActionCard.Tag)`
  background: #8500FF;
`;

export default withRouter(withUser(ReminderCard));